import { ReportGenerator } from "@intentsify/types";
import { useSyncExternalStore } from "react";

/**
 * Admin opt-in for Weekly Snapshot and Program Review PDFs generated in
 * job-runner (the new look) instead of the Python worker. Stored per browser
 * like the "New look" switch; portal-api ignores the choice for non-admins.
 */
export const NEW_REPORTS_STORAGE_KEY = "intentsify-new-reports";

const listeners = new Set<() => void>();

const read = () => {
  try {
    return window.localStorage.getItem(NEW_REPORTS_STORAGE_KEY) === "on";
  } catch {
    return false;
  }
};

export const isNewReportsEnabled = read;

export const setNewReports = (enabled: boolean) => {
  try {
    if (enabled) {
      window.localStorage.setItem(NEW_REPORTS_STORAGE_KEY, "on");
    } else {
      window.localStorage.removeItem(NEW_REPORTS_STORAGE_KEY);
    }
  } finally {
    listeners.forEach((listener) => listener());
  }
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useNewReports = () => useSyncExternalStore(subscribe, read);

/** Generator to request; omitted (worker) unless the switch is on. */
export const requestedReportGenerator = () =>
  read() ? ReportGenerator.JobRunner : undefined;
